<template>
  <div class="mt-80 home-section-main">
    <div :class="[isMobileLayout ? 'container' : 'home-container']">
      <!-- Home carousel -->
      <mq-layout :mq="['xs', 'sm', 'md']">
        <el-image
        v-if="HeaderSelectedIndex == 0"
          class="header-image__dimension"
          :src="homeHeaderCarousel.image"
          :fit="'cover'"
        />
        <div class="home-header" style="height: 195px">
          <!-- eslint-disable-next-line -->
          <h1
            class="text-center text-uppercase home-title"
            v-html="homeHeaderCarousel.title"
          />
        </div>
        <div class="text-center home-mobile">
          <el-button
            type="primary"
            :loading="loadingPDF"
            @click="getPDF(['IP'], homeHeaderCarousel.btnLink1)"
          >
            {{ countryCode == 'ON' &&  homeHeaderCarousel.btn1On ? homeHeaderCarousel.btn1On : homeHeaderCarousel.btn1 }}
          </el-button>
          <!-- <el-button
            type="primary"
            class="button-dimension button-dimension--mobile mt-10"
            @click="generatePdf(['SAQ'], homeHeaderCarousel.btnLink2)"
          >
            {{ homeHeaderCarousel.btn2 }}
          </el-button> -->

          <el-button
            v-if="homeHeaderCarousel.btn3 == 'Toronto'"
            type="primary"
            class="button-dimension button-dimension--mobile mt-10"
            :loading="loadingPDF"
            @click="getPDF(['SAQ'], homeHeaderCarousel.btnLink3)"
          >
            {{ homeHeaderCarousel.btn3 }}
          </el-button>
          <el-link
            v-else
            type="primary header-btn-3"
            class="button-dimension button-dimension--mobile mt-10"
            @click="goTo(homeHeaderCarousel.btnLink3)"
          >
            {{ homeHeaderCarousel.btn3 }}
          </el-link>
        </div>
      </mq-layout>
      <mq-layout mq="lg+">
        <div class="flex">
          <div v-if="HeaderSelectedIndex == 0" style="width: 250px">
            <el-image
              :style="{
                width: HeaderSelectedIndex == 1 ? 'auto' : '',
                minHeight: '250px',
              }"
              :class="['header-image__dimension']"
              :src="homeHeaderCarousel.image"
              :fit="'cover'"
            />
          </div>
          <div :class="HeaderSelectedIndex == 0 ? 'ml-37' : ''" style="width: 921px">
            <div class="home-header" style="height: 195px">
              <!-- eslint-disable-next-line -->
              <h1
                class="text-left text-uppercase home-title"
                v-html="homeHeaderCarousel.title"
              />
            </div>
            <div style="height: 15px" />
            <div
              :class="[
                'text-left mb-4 button-dimension',
                HeaderSelectedIndex == 1 ? 'header-screen-2' : '',  
              ]"
            >
              <el-button
                type="primary"
                @click="getPDF(['IP'], homeHeaderCarousel.btnLink1)"
                :loading="loadingPDF"
              >
                {{ countryCode == 'ON' &&  homeHeaderCarousel.btn1On ? homeHeaderCarousel.btn1On : homeHeaderCarousel.btn1 }}
              </el-button>
              <!-- <el-button
                type="primary"
                class="ml-20"
                @click="generatePdf(['SAQ'], homeHeaderCarousel.btnLink2)"
              >
                {{ homeHeaderCarousel.btn2 }}
              </el-button> -->
              <el-button
                v-if="homeHeaderCarousel.btn3 == 'Toronto'"
                type="primary"
                class="ml-20"
                :loading="loadingPDF"
                @click="getPDF(['SAQ'], homeHeaderCarousel.btnLink3)"
              >
                {{ homeHeaderCarousel.btn3 }}
              </el-button>
              <el-link
                v-else
                type="primary header-btn-3"
                class="ml-20"
                @click="goTo(homeHeaderCarousel.btnLink3)"
              >
                {{ homeHeaderCarousel.btn3 }}
              </el-link>
            </div>
          </div>
        </div>
      </mq-layout>
      <!-- <div class="mt-60 home-carousel-main">
        <HomePaginationWidget
          :nb-page="homeCarouselTotalPages"
          @emit-selected-page-change="onProviderSelectedHeaderChanged"
          class="home-carousel"
        />
      </div> -->
      <!-- <el-divider class="m-0 mt-18" /> -->
      <!-- Product carousel -->
      <div class="mt-125 home-carousel-product">
        <div>
          <el-tabs  v-model="activeName">
            <el-tab-pane v-for="(data,index) in getCarousel" :key="index"
              :label="data.name"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <ProductCarousel
          v-if="reRanderCarouselProduct"
          :products="getCarouselProducts()"
          :tax-code="actionBar && actionBar.tax"
          arrow="always"
          class="carousel-center"
          id="product-carousel"
        />
        <div class="text-left mt-10 mr-0">
          <router-link
            :to="productsView"
            :class="[
              'el-link el-link--primary is-underline',
              isMobileLayout ? 'all-products__mobile' : '',
            ]"
          >
            <span class="el-link--inner">
              {{ ctaAllProducts }}
            </span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Blog carousel - producer  -->
    <div
      class="mt-100 provider-carousel"
      :style="{ width: '100%', height: isMobileLayout ? '720px' : '435px' }"
    >
      <BlogCarousel
        :carousel-type="3"
        :blogs="topProvidersBlog"
        arrow="always"
        :selected-index="providerSelectedIndex"
      />
    </div>
    <div class="text-right mt-10 mb-33 container d-none">
      <HomePaginationWidget
        v-if="isReady"
        :class="[
          isMobileLayout
            ? 'pagination--mobile'
            : 'provider-carousel__pagination',
        ]"
        :nb-page="providerCarouselTotalPages"
        @emit-selected-page-change="onProviderSelectedPageChanged"
      />
    </div>

    <div class="container">
      <!-- Blog carousel - videos  -->
      <div :class="[isMobileLayout ? 'mt-50' : 'mt-140', 'text-left']">
        <el-row>
          <el-col :span="isMobileLayout ? 12 : 3">
            <h2 class="title text-uppercase mb-15 ml-5">
              {{ titleVideos }}
            </h2>
          </el-col>
          <el-col
            :span="isMobileLayout ? 12 : 21"
            :class="[isMobileLayout ? 'text-right mt-4' : 'pl-10']"
          >
            <router-link
              :to="videosView"
              :class="[
                'el-link el-link--primary',
                isMobileLayout ? 'all-products__mobile' : 'ml-15 mt-10',
              ]"
            >
              <span class="el-link--inner video-link">
                {{ allVideosLink }}
              </span>
            </router-link>
          </el-col>
        </el-row>

        <el-row>
          <!-- <BlogVideo v-for="(video, index) in blogVideos" :key="index"
            :title="video.user.firstName+' '+video.user.lastName"
            :description="video.title"
            :link="video.videoLink"
            :thumbnail-image="(video.mainImage ? video.mainImage.thumbnailLink : youThumbnailImg)"
          /> -->
          <div class="blog-carousel home-blog-carousel home-video-carousel">
          <BlogVideoCarousel
            :carousel-type="2"
            :blogs="blogVideos"
            arrow="always"
            :class="[isMobileLayout ? 'mt-12' : '']"
          />
          </div>
        </el-row>
      </div>
      <!-- Blog carousel - videos  -->

      <div :class="[isMobileLayout ? 'mt-50' : 'mt-140', 'text-left']">
        <el-row>
          <el-col :span="isMobileLayout ? 12 : 3">
            <h2 class="title text-uppercase mb-15 ml-5">
              {{ titleBlogs }}
            </h2>
          </el-col>
          <el-col
            :span="isMobileLayout ? 12 : 21"
            :class="[isMobileLayout ? 'text-right mt-4' : 'pl-10']"
          >
            <router-link
              :to="blogsView"
              :class="[
                'el-link el-link--primary is-underline',
                isMobileLayout ? 'all-products__mobile' : 'ml-15 mt-10',
              ]"
            >
              <span class="el-link--inner">
                {{ allBlogsLink }}
              </span>
            </router-link>
          </el-col>
        </el-row>
        <div class="blog-carousel home-blog-carousel">
          <BlogCarousel
            :carousel-type="2"
            :blogs="topBlogs"
            arrow="always"
            :class="[isMobileLayout ? 'mt-12' : '']"
          />
        </div>
      </div>
      <!-- Blog carousel - blogues  -->
      <div
        v-if="blogues"
        :class="[isMobileLayout ? 'mt-65' : 'mt-100', 'text-left']"
      >
        <el-row>
          <el-col :span="isMobileLayout ? 12 : 4">
            <h2 class="title text-uppercase mb-15 ml-5">
              {{ titleBlogs }}
            </h2>
          </el-col>
          <el-col
            :span="isMobileLayout ? 12 : 20"
            :class="[isMobileLayout ? 'text-right mt-4' : 'pl-10']"
          >
            <router-link
              :to="blogsView"
              :class="[
                'el-link el-link--primary is-underline',
                isMobileLayout ? 'all-products__mobile' : 'ml-15 mt-10',
              ]"
            >
              <span class="el-link--inner">
                {{ allBlogsLink }}
              </span>
            </router-link>
          </el-col>
        </el-row>
        <BlogCarousel
          :carousel-type="1"
          :blogs="topBlogs"
          arrow="always"
          :class="[isMobileLayout ? 'mt-24' : '']"
        />
      </div>

      <!-- Static content - become member -->
      <div
        v-if="becomeMember"
        :class="[
          isMobileLayout ? 'become-member--mobile' : '',
          'text-left flex become-member',
        ]"
        style="height: 333px; margin-left: 10px;"
      >
        <div
          class="mt-88 become-member-sub"
          style="width: 546px; margin-left: -1px"
        >
          <h2 class="title text-uppercase">
            {{ becomeMemberTitle }}
          </h2>
          <div
            :class="['blog-content', isMobileLayout ? 'mt-10' : 'mt-6']"
            :style="{
              width: isMobileLayout ? '100%' : '480px',
              height: isMobileLayout ? '96px' : '66px',
              'line-height': '22px',
              'letter-spacing': '0.5px !important',
              color: '#272421',
              'font-weight': '300',
            }"
          >
            {{ becomeMemberContent }}
          </div>
          <div
            :class="[
              isMobileLayout ? 'mt-30 flex img-btn' : 'mt-40',
              'text-left',
            ]"
          >
            <el-button
              type="primary"
              @click="goTo('membres')"
              :class="[
                isMobileLayout
                  ? 'button__read-all--mobile'
                  : 'button__read-all',
              ]"
            >
              {{ ctaReadMore }}
            </el-button>
            <el-image
              v-if="isMobileLayout"
              class="ml-40 image"
              style="width: 209px; height: 209px; margin-top: -30px"
              :src="images.becomeMember.src"
              :fit="'contain'"
            />
          </div>
        </div>
        <el-image
          v-if="!isMobileLayout"
          class="ml-1"
          style="width: 333px; height: 333px"
          :src="images.becomeMember.src"
          :fit="'contain'"
        />
      </div>
    </div>
    <div
      v-if="
        reRander == true &&
        products &&
        products.results &&
        products.results.length > 0
      "
      ref="createPdf"
      id="print"
    >
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :pdf-quality="2"
          :manual-pagination="true"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="100%"
          :html-to-pdf-options="htmlToPdfOptions"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <div class="pdf-logo mb-20">
              <img :src="image.logo" alt="" class="pdf-logo-img" />
            </div>
            <ProductCardsList
              id="product-cards-list-lg product-cards-pdf"
              :products="products && products.results"
              :tax-code="actionBar && actionBar.tax"
              :span="$mq === 'lg' ? 8 : 6"
              :is-filter-visible="isFilterVisible"
              :list-type="'liste'"
              :filters="filters"
            />
          </section>
        </vue-html2pdf>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import goTo from "../../mixins/goTo";
import { get, isEmpty, reverse, take } from "@/utils/lodash";

const byPublishedDateDesc = (a, b) => {
  const da = a && a.publishedDate ? new Date(a.publishedDate).getTime() : 0;
  const db = b && b.publishedDate ? new Date(b.publishedDate).getTime() : 0;
  return db - da;
};
import layoutUtils from "@/utils/layout-utils";
import { getDefaultAvailability } from "@/utils/market-utils";
import { sortByHierarchyWithAlternation } from "@/utils/carousel-sort-utils";

import imgHeader from "@/assets/images/home/home-header-image-original.png";
import imgBecomeMember from "@/assets/images/home/home-become-member-image.png";
import imgDiscovery from "@/assets/images/home/home-discovery-packages-image.png";
import homeStaicBlog from "@/assets/images/home/home-static-blog.jpeg";

import ProductCarousel from "@/views/product/components/product-carousel.vue";
import BlogCarousel from "@/views/blog/components/blog-carousel.vue";
import BlogVideoCarousel from "@/views/blog/components/blog-video-carousel.vue";
// import BlogVideo from "@/views/blog/components/blog-video.vue";
import HomePaginationWidget from "./components/home-pagination-widget.vue";
import ProductCardsList from "@/views/product/components/product-cards-list.vue";
import pdfLogo from "@/assets/images/logo/logo-red.png";
import VueHtml2pdf from "vue-html2pdf";
import "vue-plyr/dist/vue-plyr.css";
import "@fancyapps/ui/dist/fancybox.css";
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox";
import youThumbnail from "@/assets/images/home/you-thumbnail.jpg";

export default {
  mixins: [goTo],
  components: {
    HomePaginationWidget,
    ProductCarousel,
    BlogCarousel,
    // BlogVideo,
    ProductCardsList,
    VueHtml2pdf,
    BlogVideoCarousel
  },
  data() {
    return {
      title: "Home",
      images: {
        header: {
          src: imgHeader,
        },
        becomeMember: {
          src: imgBecomeMember,
        },
        discoveryPackages: {
          src: imgDiscovery,
        },
      },
      isMounted: false,
      providerSelectedIndex: 0,
      maximumProviderCarouselPages: 3,
      homeCarouselTotalPages: 2,
      totalBlogs: 3,
      isReady: false,
      blogues: false,
      becomeMember: true,
      activeName: 0,
      homeHeaderCarousel: [],
      HeaderSelectedIndex: 0,
      isFilterVisible: true,
      htmlToPdfOptions: {
        margin: [0.1, 0.2, 0.3, 0],
        filename: `${Math.round(+new Date() / 1000)}.pdf`,
        image: {
          type: "jpeg",
          quality: 2,
        },
        enableLinks: false,
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
        },
      },
      image: {
        logo: pdfLogo,
      },
      reRander: false,
      productBtnLinkWidth: this.$i18n.locale == "en-US" ? "" : "147px",
      countryCode: localStorage.getItem("countryCode"),
      youThumbnailImg: youThumbnail,
      loadingPDF: false,
      newWindow: null,
      reRanderCarouselProduct: true,
    };
  },
  computed: {
    ...mapState("product", ["products", "filters", "carousel"]),
    ...mapState("blog", ["blogs"]),
    ...mapState("configuration", ["actionBar"]),

    getCarousel() {
      return this.carousel && this.carousel.products;
    },

    titleLabel() {
      return this.$i18n.t("home.homeView.title");
    },
    ctaPrintListIp() {
      return this.$i18n.t("home.homeView.headerCarousel.printListIp");
    },
    ctaPrintListSaq() {
      return this.$i18n.t("home.homeView.headerCarousel.printListSaq");
    },
    ctaExploreAgencyProduct() {
      return this.$i18n.t("home.homeView.headerCarousel.exploreAgencyProduct");
    },
    ctaAllProducts() {
      return this.$i18n.t("home.homeView.productCarousel.allProducts");
    },
    titleVideos() {
      return this.$i18n.t("home.homeView.blogVideosCarousel.title");
    },
    title1Video() {
      return this.$i18n.t("home.homeView.blogVideo1Carousel.title");
    },
    title1Description() {
      return this.$i18n.t("home.homeView.blogVideo1Carousel.description");
    },
    title2Video() {
      return this.$i18n.t("home.homeView.blogVideo2Carousel.title");
    },
    title2Description() {
      return this.$i18n.t("home.homeView.blogVideo2Carousel.description");
    },
    title3Video() {
      return this.$i18n.t("home.homeView.blogVideo3Carousel.title");
    },
    title3Description() {
      return this.$i18n.t("home.homeView.blogVideo3Carousel.description");
    },
    allVideosLink() {
      return this.$i18n.t("home.homeView.blogVideosCarousel.allVideosLink");
    },
    titleBlogs() {
      return this.$i18n.t("home.homeView.blogsCarousel.title");
    },
    allBlogsLink() {
      return this.$i18n.t("home.homeView.blogsCarousel.allBlogsLink");
    },
    becomeMemberTitle() {
      return this.$i18n.t("home.homeView.becomeMember.title");
    },
    becomeMemberContent() {
      return this.$i18n.t("home.homeView.becomeMember.content");
    },
    discoveryPackagesTitle() {
      return this.$i18n.t("home.homeView.discoveryPackages.title");
    },
    discoveryPackagesContent() {
      return this.$i18n.t("home.homeView.discoveryPackages.content");
    },
    ctaReadMore() {
      return this.$i18n.t("home.homeView.cta.readMore");
    },
    valentinesDayLabel() {
      return this.$i18n.t("home.category.valentinesDay");
    },
    newsLabel() {
      return this.$i18n.t("home.category.news");
    },
    inStoreLabel() {
      return this.$i18n.t("home.category.inStore");
    },
    providerCarouselTotalPages() {
      return this.topProviders.length > this.maximumProviderCarouselPages
        ? this.maximumProviderCarouselPages
        : this.topProviders.length;
    },
    topProviders() {
      return [
        {
          title: this.$i18n.t("home.homeView.blogCarouselStatic.title"),
          subTitle: this.$i18n.t("home.homeView.blogCarouselStatic.subTitle"),
          content: this.$i18n.t("home.homeView.blogCarouselStatic.content"),
          mainImage: {
            link: homeStaicBlog,
          },
        },
      ];
    },
    topVideos() {
      const blogs = get(this.blogs, "results");
      if (!isEmpty(blogs)) {
        const sorted = reverse(blogs);
        const val = take(
          sorted,
          this.isMobileLayout ? this.totalBlogs : blogs.length
        );
        return val;
      }

      return [];
    },
    topBlogs() {
      const blogs = get(this.blogs, "results");

      if (!isEmpty(blogs) && blogs.length > 0) {
        const blogData = blogs.filter( (b) =>
          b.id != null &&
          b.videoLink == null &&
          b.type.code == "DEFAULT"
      );
        return [...blogData].sort(byPublishedDateDesc);
      }

      return [];
    },
    topProvidersBlog() {
      const blogs = get(this.blogs, "results");
      if (!isEmpty(blogs) && blogs.length > 0) {
        const blog = blogs.filter((b) => get(b, "type.code") === "PROCUCER");
        return [...blog].sort(byPublishedDateDesc);
      }

      return [];
    },

    productsView() {
      return {
        name: "products",
        params: {},
      };
    },
    videosView() {
      return {
        name: "blogs",
        params: {
          types: ["VIDEOS_SAQ", "VIDEOS_IP"],
        },
        query: {
          type: "VIDEO",
        },
      };
    },
    blogsView() {
      return {
        name: "blogs",
        params: {
          types: "TEXTE_PHOTOS",
        },
      };
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    headerCarousel() {
      return this.$i18n.t("home.headerCarousel");
    },
    videoLink1() {
      return "https://www.youtube.com/watch?v=g1kUjw5ir4w";
    },
    videoLink2() {
      return "https://www.youtube.com/watch?v=aFTu94REGWM";
    },
    videoLink3() {
      return "https://www.youtube.com/watch?v=HgRgavcWBQs";
    },
    blogVideos() {
      const blogs = get(this.blogs, "results");
      if (!isEmpty(blogs)) {
        const blog = blogs.filter( (b) =>
          b.id != null &&
          b.videoLink != null
      );
        // const sorted = reverse(blog);
        return take(
          blog,
          this.isMobileLayout ? this.totalBlogs : blogs.length
        );
      }

      return [];
    },
  },
  watch: {
  //   '$i18n.locale': {
  //   async handler() {
  
  //     await this.fetchBlogs({ filters: { sortByDate: "DESC" } });
  //     this.getProductCarouselProduct();
  //   },
  //   immediate: true,
  // },
    topProviders() {
      if (this.topProviders.length > 0) {
        this.isReady = true;
      }
    },
    headerCarousel() {
      this.hendlerheaderCarousel(this.currentIndex);
    },
    products(val) {
      if (!val || !val.results) return;
      const market = localStorage.getItem("countryCode") || "QC";
      const allowedCodes = getDefaultAvailability(market).map(c => c.toUpperCase());
      val.results.forEach((e) => {
        if (e.productInventories) {
          let price = e.productInventories.find((r) =>
            r.id == e.id && allowedCodes.indexOf(r.inventory.code.toUpperCase()) !== -1
          );
          if (price) {
            e.erpProduct = price;
            e.inventory = price.inventory;
            e.pricing = price.pricing;
          }
        }
      });
    },
  },
  created() {
    this.fetchProducts({});
    this.fetchBlogs({ filters: { sortByDate: "DESC" } });
    this.hendlerheaderCarousel();
    this.fetchProductFilters({});
  },
  mounted() {
    this.isMounted = true;
    this.getProductCarouselProduct()
    // Keep handler references so beforeDestroy can $off them. Without cleanup
    // these $root listeners leak on every visit and all fire on a region/lang
    // switch (slow region switch).
    this.$_onLang = () => {
      this.productBtnLinkWidth =
        this.$i18n.locale == "en-US" ? "102px" : "147px";
        this.fetchBlogs({ filters: { sortByDate: "DESC" } });
        this.getProductCarouselProduct();
    };
    this.$_onCountry = (countryCode) => {
      this.countryCode = countryCode;
      this.getProductCarouselProduct()
    };
    this.$_onTax = () => {
      this.reRenderProductView()
    };
    this.$root.$on("chanLang", this.$_onLang);
    this.$root.$on("chancountryCode", this.$_onCountry);
    this.$root.$on("changeTax", this.$_onTax);
  },
  beforeDestroy() {
    this.$root.$off("chanLang", this.$_onLang);
    this.$root.$off("chancountryCode", this.$_onCountry);
    this.$root.$off("changeTax", this.$_onTax);
  },
  methods: {
    ...mapActions("product", ["fetchProducts", "fetchProductFilters", "fetchCarouselProducts", "downloadPDF"]),
    ...mapActions("blog", ["fetchBlogs"]),

    getProductCarouselProduct() {
      this.fetchCarouselProducts({group: this.countryCode == 'ON' ?  'HOME_ON' : 'HOME_QC'}).then(() => {
      });
    },
    onProviderSelectedPageChanged(selectedIndex) {
      this.providerSelectedIndex = selectedIndex;
    },

    hendlerheaderCarousel(index = 0) {
      this.HeaderSelectedIndex = index;
      this.currentIndex = index;
      this.homeHeaderCarousel = this.headerCarousel[index];
    },
    onProviderSelectedHeaderChanged(selectedIndex) {
      this.hendlerheaderCarousel(selectedIndex);
    },
    getProducts(filters) {
      this.fetchProducts({
        filters,
      });
    },
    getPDF(type, link) {
      this.loadingPDF = true;
      this.newWindow = window.open('', '_blank');
      if (this.newWindow) {
        this.newWindow.document.write('<html><head><title>PDF</title></head><body>');
        this.newWindow.document.write('<h4>Loading PDF...</h4>');
        this.newWindow.document.write('</body></html>');
      } else {
        console.error('Failed to open new window');
      }
      if (link !== "") {
        this.goTo(link);
      }
      this.reRander = true;
      var filter = [];
      this.pdfGenerate(filter)
    },
    pdfGenerate(filters) {
      localStorage.setItem('taxcode', this.actionBar.tax);
      this.downloadPDF({
        filters,
      }).then((res) => {
        if (this.newWindow && res) {
          this.newWindow.location.href = res;
        }
        this.loadingPDF = false;
      }).catch(() => {
        this.loadingPDF = false;
        if (this.newWindow) this.newWindow.close();
      })
    },
    generatePdf(type, link = "") {
      if (link !== "") {
        this.goTo(link);
      }
      this.reRander = true;
      var filter = [];
      filter = {
        availability: type,
      };
      this.getProducts(filter);
      setTimeout(() => {
        this.generateReport();
        this.getProducts();
      }, 2000);
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    getCarouselProducts() {
      if (
        this.getCarousel &&
        this.getCarousel[this.activeName] &&
        this.getCarousel[this.activeName].contents
      ) {
        const products = this.getCarousel[this.activeName].contents.filter(
          (product) => product !== null);
        const market = localStorage.getItem("countryCode") || "QC";
        return sortByHierarchyWithAlternation(products, market);
      }
      return [];
    },
    fancyBox() {
      Fancybox.show({}, {});
    },
    reRenderProductView() {
      this.reRanderCarouselProduct = false;
      this.$nextTick(() => {
        this.reRanderCarouselProduct = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
$header-image-size-sm: 115px;
$header-image-size-lg: 146px;

.home-container {
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
}
.header-image__dimension {
  // sm -
  @media screen and (max-width: $media-md) {
    width: $header-image-size-sm;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $header-image-size-lg;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $header-image-size-lg;
  }
}
.home-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffffed;
  z-index: 1;
  position: relative;
}
.home-title {
  letter-spacing: 0.6px;
  color: rgb(39, 36, 33);

  // sm -
  @media screen and (max-width: $media-md) {
    font-weight: $font-weight-bold-condensed;
    line-height: 36px;
  }
  // md +
  @media screen and (min-width: $media-md) {
    font-weight: $font-weight-bold;
    line-height: 50px;
  }
}
.home-carousel {
  display: inline-block;
  text-align: right;
}
.button-dimension {
  height: 35px;
}
.button-dimension--mobile {
  width: 204px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button__read-all {
  height: 40px;
  font-size: 16px;
  width: 138px;
}
.button__read-all--mobile {
  height: 35px;
  font-size: 14px;
  width: 122px;
  padding-left: 8px !important;
}
.title {
  color: $color-on-background;
}
.all-products__mobile {
  font-size: 14px;
}
.provider-carousel {
  background-color: $color-primary;
}
.provider-carousel__pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: -73px;
}
.pagination--mobile {
  display: flex;
  justify-content: center;
}
.become-member--mobile {
  margin-top: -60px;
}
.d-none {
  display: none;
}
.header-btn-3 {
  font-size: 16px;
}
.home-carousel-main {
  text-align: right;
}
.home-header {
  // sm -
  @media screen and (max-width: $media-md) {
    margin-top: 0px;
  }

  @media screen and (max-width: $media-sm) {
    height: unset !important;
    margin-bottom: 8px;
    padding-top: 8px;
  }
}
.home-carousel-main {
  @media screen and (max-width: $media-md) {
    text-align: center;
  }
}
.header-screen-2 {
  .el-button {
    width: 170px;
  }
}
.video-link {
  text-decoration: underline;
}
.video-link :hover {
  text-decoration: none;
}
.home-mobile {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;

}
</style>
